export default [
    {
        path: "/teacher/classList",
        name: "teacher_classList",
        component: () => import(/* webpackChunkName: "teacher_classList" */ "../views/teacher/TeacherClassList.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/teacher/class/:class_id",
        component: () => import(/* webpackChunkName: "teacher_classBase" */ "../views/teacher/ClassBase.vue"),
        props: true,
        meta: { requiresAuth: true },
        children: [
            {
                path: "enrollment",
                name: "teacher_classEnrollment",
                props: true,
                component: () => import(/* webpackChunkName: "teacher_classEnrollment" */ "../views/teacher/class-actions/StudentList.vue"),
                meta: { requiresAuth: true }
            },
            {
                path: "notify",
                name: "teacher_notifyClass",
                props: true,
                component: () => import(/* webpackChunkName: "teacher_notifyClass" */ "../views/teacher/class-actions/NotifyParents.vue"),
                meta: { requiresAuth: true }
            },
            {
                path: "notifications",
                name: "teacher_viewNotifications",
                props: true,
                component: () => import(/* webpackChunkName: "teacher_viewNotifications" */ "../views/teacher/class-actions/ViewPreviousNotifications.vue"),
                meta: { requiresAuth: true }
            },
            {
                path: "attendance",
                name: "teacher_viewAttendance",
                props: true,
                component: () => import(/* webpackChunkName: "teacher_viewAttendance" */ "../views/teacher/class-actions/Attendance.vue"),
                meta: { requiresAuth: true }
            },
            {
                path: "past-attendance",
                name: "teacher_viewPastAttendance",
                props: true,
                component: () => import(/* webpackChunkName: "teacher_viewPastAttendance" */ "../views/teacher/class-actions/PastAttendance.vue"),
                meta: { requiresAuth: true }
            }
        ]
    }
]